// extracted by mini-css-extract-plugin
export default {"headerAlignment":"HoltC2","contentAlignment":"kfUjJ6","contentAlignmentJustify":"kXLuaV"};